import React from 'react';
import { Link } from 'react-router-dom';
import Navbar from "./Navbar";
import Footer from "./Footer.jsx";
import './LegalPages.css';

const TermsOfUse = () => {
  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Navbar />
      <div className="legal-page-container">
        <div className="legal-content">
          <div className="legal-header">
            <h1>Terms of Use</h1>
            <p>Last Updated: January 1, 2025</p>
          </div>

          <div className="legal-section">
            <h2>1. Acceptance of Terms</h2>
            <p>By accessing or using the Royal Heritage Fiesta website, you agree to be bound by these Terms of Use. If you do not agree with any part of these terms, please do not use our website or services.</p>
          </div>

          <div className="legal-section">
            <h2>2. Description of Services</h2>
            <p>Royal Heritage Fiesta provides event planning, ticketing, stall booking, and related services for heritage-themed celebrations, royal dinners, music concerts, and other special events. We reserve the right to modify, suspend, or discontinue any service at any time without notice.</p>
          </div>

          <div className="legal-section">
            <h2>3. User Accounts</h2>
            <p>To access certain features, you may need to create an account. You are responsible for:</p>
            <ul>
              <li>Maintaining the confidentiality of your account information</li>
              <li>All activities that occur under your account</li>
              <li>Notifying us immediately of any unauthorized account use</li>
              <li>Providing accurate and complete registration information</li>
            </ul>
          </div>

          <div className="legal-section">
            <h2>4. Event Registrations & Ticketing</h2>
            <p>When you register for an event or purchase tickets:</p>
            <ul>
              <li>All ticket sales are subject to availability</li>
              <li>Prices are subject to change without notice</li>
              <li>You must provide accurate information for registration</li>
              <li>Event schedules, artists, and venues may change - we will notify you of significant changes</li>
              <li>Please review our <Link to="/refund">No Refund Policy</Link> for ticket cancellations</li>
            </ul>
          </div>

          <div className="legal-section">
            <h2>5. Stall Booking Terms</h2>
            <p>For stall bookings at our events:</p>
            <ul>
              <li>Stall allocations are confirmed only upon full payment</li>
              <li>Stall assignments are at our discretion and may be changed if necessary</li>
              <li>You must comply with all event rules, safety regulations, and local laws</li>
              <li>We reserve the right to cancel any booking that violates our policies</li>
              <li>Refunds for stall bookings follow the <Link to="/refund">No Refund Policy</Link></li>
            </ul>
          </div>

          <div className="legal-section">
            <h2>6. Prohibited Conduct</h2>
            <p>You agree not to:</p>
            <ul>
              <li>Use our website for any unlawful purpose</li>
              <li>Attempt to gain unauthorized access to our systems</li>
              <li>Interfere with or disrupt our services</li>
              <li>Harass, abuse, or harm others through our platform</li>
              <li>Impersonate any person or entity</li>
              <li>Resell tickets for profit without authorization</li>
            </ul>
          </div>

          <div className="legal-section">
            <h2>7. Intellectual Property</h2>
            <p>All content on this website, including text, graphics, logos, images, and software, is the property of Royal Heritage Fiesta and protected by copyright and intellectual property laws. You may not reproduce, distribute, or create derivative works without our express written permission.</p>
          </div>

          <div className="legal-section">
            <h2>8. Limitation of Liability</h2>
            <p>To the fullest extent permitted by law, Royal Heritage Fiesta shall not be liable for any indirect, incidental, special, consequential, or punitive damages arising from your use of our services. Our total liability shall not exceed the amount you paid for our services.</p>
          </div>

          <div className="legal-section">
            <h2>9. Disclaimer of Warranties</h2>
            <p>Our services are provided "as is" without any warranties, express or implied. We do not guarantee that our website will be uninterrupted, error-free, or free of viruses or other harmful components.</p>
          </div>

          <div className="legal-section">
            <h2>10. Indemnification</h2>
            <p>You agree to indemnify and hold Royal Heritage Fiesta harmless from any claims, damages, losses, liabilities, costs, or expenses arising from your violation of these Terms of Use.</p>
          </div>

          <div className="legal-section">
            <h2>11. Governing Law</h2>
            <p>These Terms shall be governed by the laws of India. Any disputes arising shall be subject to the exclusive jurisdiction of the courts in Hyderabad, Telangana.</p>
          </div>

          <div className="legal-section">
            <h2>12. Changes to Terms</h2>
            <p>We reserve the right to modify these Terms at any time. Continued use of our services after changes constitutes acceptance of the modified Terms.</p>
          </div>

          <div className="legal-section">
            <h2>13. Contact Information</h2>
            <p>For questions about these Terms, please contact us:</p>
            <ul>
              <li>Email: <a href="mailto:royalheritagefiesta@gmail.com">royalheritagefiesta@gmail.com</a></li>
              <li>Phone: +91 99662 52374</li>
            </ul>
          </div>

          <div className="legal-footer">
            <Link to="/" className="back-home-btn">← Back to Home</Link>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default TermsOfUse;